'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";
import {checklistsModel} from "../../models/checklistsmodel.js";
import {evlCriterionModel} from "../../models/evlcriterionmodel.js";

export class InvitationChecklistCtrl extends EvaluationBaseCtrl
{
//	$scope;
//	$filter;
//	$timeout;
//	jsDataService;
//	notify;
//	evaluation = {};

//	showRequire = false;
//	
//	constructor($scope, $filter, $timeout, jsDataService, notify){
//		'ngInject';
//		this.$scope = $scope;
//		this.$filter = $filter;
//		this.jsDataService = jsDataService;
//		this.notify = notify;
//		this.$timeout = $timeout;
//		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.evaluation = new evaluationAdmeliModel(jsDataService.get('evaluation', {}), $filter, jsDataService);
//		
//	}
	
	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new checklistsModel(evaluation, this.$filter, this.jsDataService);
		
		this.changeUrl = this.jsDataService.get('changeUrl', '');
		this.cancelChangeUrl = this.jsDataService.get('cancelChangeUrl', '');
		this.pendingUrl = this.jsDataService.get('pendingUrl', '');
		this.confirmUrl = this.jsDataService.get('confirmUrl', '');
	}
	
	getCriteria(){
		return this.evaluation.form_data.getCriteriaList();
	}
	
	cancel = function(){
		const url = this.jsDataService.get('previewUrl');
		if(url){
			this.$scope.goUrl(url);
		}
	};

	save = function(){
		this.saveData();
	};

	saveData = function(){
//		console.log(this.jsDataService.get('saveUrl'))
		if(this.jsDataService.get('saveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('saveUrl'),
				method: 'POST',
				data: {
					criteria: this.evaluation.form_data.getCriteriaData(),
				}
			}).then((response) => {

			});
	   }
	   return null;
   };

	change(){
		if(this.changeUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.changeUrl,
				method: 'GET'
			});
		}
	}

	pendingChange(ev){
		if(this.pendingUrl !== ''){
			const confirmTexts = this.jsDataService.get('pendingConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.pendingUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	confirm(ev){
		if(typeof(this.removeUrl) !== 'undefined' && this.confirmUrl !== ''){
			const confirmTexts = this.jsDataService.get('confirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.confirmUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	cancelChange(ev){
		if(typeof(this.cancelChangeUrl) !== 'undefined' && this.cancelChangeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cancelChangeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	publishChange(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.publishChangeDialogCtrl],
			templateUrl: 'invitations/publish_change.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {

			}
		}).then((results) => {
			if(typeof(this.item.status_url) !== 'undefined'){
				this.$scope.$root.basicHttpConfigProcess({
					url: this.item.status_url,
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}
		}, () => {});

	}

	publishDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectUrl')) !== 'undefined' && jsDataService.get('rejectUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishUrl')) !== 'undefined' && jsDataService.get('publishUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}

	publishChangeDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectChangeUrl')) !== 'undefined' && jsDataService.get('rejectChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishChangeUrl')) !== 'undefined' && jsDataService.get('publishChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}
	
    addNewCriteria = function() {
		const keys = Object.keys(this.evaluation.form_data.criteria);
		let lastIndex = keys.reduce((max, key) => {
			const match = key.match(/^cr(\d+)$/);
			return match ? Math.max(max, parseInt(match[1], 10)) : max;
		}, 0);
		const newIndex = lastIndex + 1;
		const newKey = `cr${newIndex}`;
		
		const data = {
			id: newKey,
			title: '',
			instruction: '',
			hidden: '',
			no: `${newIndex}`,
			newCriteria: true
		};
		this.evaluation.form_data.criteria[newKey] = new evlCriterionModel(data, this.$filter, this.jsDataService);
//		console.log(this.evaluation.form_data.criteria)
    };
	
    removeNewCriteria = function(ev, field) {
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				delete this.evaluation.form_data.criteria[field.id];
			}, () => {});


    };	
}